module.exports = __webpack_public_path__ + "img/jordbruk_med_paavirkningsgrad.7bcbd640.jpg";